import { render } from "./PartnerStoreDetailCard.vue?vue&type=template&id=0f8a3a09&scoped=true&ts=true"
import script from "./PartnerStoreDetailCard.vue?vue&type=script&lang=ts"
export * from "./PartnerStoreDetailCard.vue?vue&type=script&lang=ts"

import "./PartnerStoreDetailCard.vue?vue&type=style&index=0&id=0f8a3a09&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0f8a3a09"]])

export default __exports__